import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { useEarlyAccess } from "@/components/EarlyAccessModal/context";
import { Architecture } from "@/sections/Architecture";
import { Benchmarks } from "@/sections/Benchmarks";
import { BuiltWith } from "@/sections/BuiltWith";
import { CallToAction } from "@/sections/CallToAction";
import { Comparison } from "@/sections/Comparison";
import { Features } from "@/sections/Features";
import { Hero } from "@/sections/Hero";
import { Problem } from "@/sections/Problem";
import { Roadmap } from "@/sections/Roadmap";
import { Stats } from "@/sections/Stats";

export const Route = createFileRoute("/")({
	component: HomePage,
});

function HomePage(): ReactNode {
	const { open: openModal } = useEarlyAccess();

	return (
		<>
			<Hero onOpenModal={openModal} />
			<Problem />
			<Architecture />
			<Features />
			<Roadmap />
			<Comparison />
			<Stats />
			<BuiltWith />
			<Benchmarks />
			<CallToAction onOpenModal={openModal} />
		</>
	);
}
